import type { SituacaoDoTemplate } from './Campanha.scopes'

// Template da campanha para quem está fora da janela de 24 h (E29).

/**
 * Preço de referência da Meta para uma mensagem de marketing no Brasil, em dólar, consultado em 27/10/2026 (as
 * fontes variam de US$ 0,05 a 0,0625). Serve só para a estimativa da tela: o valor cobrado é o da fatura da Meta.
 */
export const CUSTO_TEMPLATE_MARKETING_USD = 0.0625

/** Estimativa do custo de mandar o template a `parceiros`, em dólar, como texto (≈ US$ 187,50). */
export function custoEstimado(parceiros: number): string {
    const valor = Math.max(parceiros, 0) * CUSTO_TEMPLATE_MARKETING_USD
    return `≈ US$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export const ROTULO_SITUACAO_TEMPLATE: Record<
    SituacaoDoTemplate,
    { rotulo: string; cor: 'default' | 'success' | 'warning' | 'error' | 'info' }
> = {
    sem_template: { rotulo: 'Sem template', cor: 'default' },
    em_analise: { rotulo: 'Em análise na Meta', cor: 'info' },
    aprovado: { rotulo: 'Aprovado', cor: 'success' },
    recusado: { rotulo: 'Recusado pela Meta', cor: 'error' },
    pausado: { rotulo: 'Pausado pela Meta', cor: 'error' },
    desatualizado: { rotulo: 'Desatualizado: o conteúdo mudou', cor: 'warning' },
    nao_encontrado: { rotulo: 'Não está mais na conta', cor: 'error' }
}

/** Público do template: todos os parceiros ou só os que atuaram nos últimos N dias (conversa, consulta ou negócio). */
export const rotuloDoPublico = (dias: number | null | undefined) =>
    dias ? `Quem atuou nos últimos ${dias} dias` : 'Todos os parceiros'
